const liveMusicNavSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
 width="35.783px" height="28.556px" viewBox="0 0 35.783 28.556" enable-background="new 0 0 35.783 28.556" xml:space="preserve">
<path fill="#1BABE2" d="M9.769,15.779c-1.915-0.389-3.784,0.85-4.174,2.764c-0.39,1.916,0.848,3.785,2.763,4.174
c1.917,0.391,3.785-0.848,4.174-2.764c0.187-0.92,0.001-1.877-0.52-2.66C11.498,16.508,10.689,15.965,9.769,15.779z M9.922,20.541
c-0.712,0.473-1.674,0.279-2.146-0.434c-0.474-0.713-0.28-1.676,0.434-2.148c0.713-0.473,1.675-0.279,2.148,0.434
c0.228,0.344,0.309,0.762,0.228,1.164C10.503,19.961,10.265,20.313,9.922,20.541z M33.712,1.092
c-0.355-0.539-0.912-0.916-1.545-1.043l0,0c-0.634-0.129-1.292,0-1.83,0.359l-3.592,2.371c-0.554,0.373-0.921,0.967-1.006,1.631
l-6.079,4.025c-2.316-1.664-5.133-1.895-7.196-0.529c-0.649,0.432-1.196,1-1.601,1.662c-0.241,0.355-0.668,0.533-1.089,0.457
c-4.642-0.688-8.961,2.512-9.658,7.152c-0.802,5.174,2.57,10.076,7.688,11.182c4.463,0.973,8.896-1.758,10.035-6.18
c0.094-0.418,0.423-0.74,0.843-0.824c0.769-0.113,1.504-0.396,2.154-0.826c2.064-1.371,2.948-4.049,2.313-6.836l6.07-4.035
c0.644,0.18,1.334,0.074,1.894-0.291l3.579-2.373c1.121-0.742,1.427-2.254,0.685-3.373c-0.001-0.002-0.001-0.002-0.001-0.002
L33.712,1.092z M33.599,5.326L30.02,7.699c-0.088,0.063-0.203,0.076-0.305,0.039l-0.316-0.107c-0.291-0.096-0.61-0.055-0.864,0.115
l-7.084,4.688c-0.371,0.246-0.532,0.709-0.395,1.133c0.708,2.17,0.174,4.311-1.32,5.303c-0.409,0.27-0.874,0.447-1.358,0.52
c-1.201,0.201-2.169,1.094-2.468,2.273l0,0c-0.406,1.561-1.37,2.918-2.708,3.816c-3.174,2.105-7.61,1.016-9.893-2.412
c-1.105-1.629-1.548-3.617-1.24-5.563c0.522-3.563,3.833-6.027,7.395-5.506C9.476,12,9.488,12,9.5,12.002
c1.204,0.186,2.403-0.359,3.056-1.387c0.25-0.42,0.59-0.777,0.993-1.053c0.832-0.525,1.839-0.697,2.799-0.477
c0.962,0.211,1.854,0.666,2.59,1.322c0.337,0.291,0.827,0.322,1.197,0.076l7.098-4.688c0.255-0.17,0.419-0.447,0.444-0.752
L27.7,4.713c0.006-0.109,0.063-0.207,0.154-0.264l3.579-2.373c0.103-0.07,0.23-0.094,0.351-0.064l0,0
c0.122,0.021,0.23,0.092,0.298,0.195l1.667,2.514c0.137,0.207,0.081,0.486-0.126,0.623L33.599,5.326z"/>
</svg>
`;

export default liveMusicNavSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/liveMusicNavSVG.js